import { ReactNode } from "react";

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export interface SortOptions {
  [column: string]: SortOrder;
}

export interface QueryOptions {
  full_text_search?: string;
  results_per_page?: number;
  result_count?: string;
  order_by?: Array<SortOptions>;
  page_number?: number;
  expected_fields?: string[];
}

export interface LabelType {
  label: string;
  value: string | number | boolean;
  test_id?: string;
  disabled?: boolean;
}

export interface Dictionary<T = string> {
  [key: string]: T;
}

export interface TableHeader {
  key: string;
  label: string;
  formatter?: (val: string | string[] | boolean) => string | ReactNode;
  isSortable?: boolean;
  className?: string;
}

export interface SelectValue {
  label: string;
  value: number;
}

export interface SelectStringValue {
  label: string;
  value: string;
}

export interface MultiTypeSelectValue {
  label: string;
  value: string | number;
}

// eslint-disable-next-line
export type EventWithDataHandler<Event> = (event?: Event, newValue?: any, previousValue?: any, name?: string) => void;

export type RequireOnly<T, K extends keyof T> = Partial<T> & Pick<T, K>;

export interface PageAlertState {
  type: string;
  show: boolean;
  message: string;
  timeout?: number;
  iconClass?: string;
}

export type ReturnTypePartial = {
  id?: string;
  type?: string;
};
